import { render, staticRenderFns } from "./Kingston.vue?vue&type=template&id=778e577a&"
import script from "./Kingston.vue?vue&type=script&lang=js&"
export * from "./Kingston.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports